import React, { useState, useEffect, useRef, useCallback } from 'react';
import QRCode from 'qrcode';

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700&family=Playfair+Display:ital,wght@0,500;0,600;1,500&display=swap');

.vt-wrap{--navy:#070b16;--panel:#0a1124;--gold:#c9a84c;--gold-lt:#e7ca72;--gold-dk:#8f6f2c;--teal:#37d0c4;--ink:#06090f;--text:#e9edf5;--muted:#9aa6bc;--line:rgba(201,168,76,.30);
  min-height:100vh;width:100%;box-sizing:border-box;
  background:
    radial-gradient(1100px 520px at 50% -8%, #16203c 0%, rgba(22,32,60,0) 60%),
    radial-gradient(820px 620px at 100% 120%, rgba(55,208,196,.10) 0%, rgba(55,208,196,0) 55%),
    linear-gradient(180deg,#070b16,#05070f);
  display:flex;align-items:flex-start;justify-content:center;padding:30px 16px 60px;
  font-family:'Playfair Display',Georgia,serif;color:var(--text);-webkit-font-smoothing:antialiased;}
.vt-frame{position:relative;width:100%;max-width:600px;background:linear-gradient(180deg,var(--panel),#070c1a);
  border:1px solid var(--line);border-radius:14px;padding:56px 42px 40px;
  box-shadow:0 40px 120px rgba(0,0,0,.6), inset 0 0 0 4px rgba(201,168,76,.05);}
.vt-frame::before{content:'';position:absolute;inset:9px;border:1px solid rgba(201,168,76,.16);border-radius:9px;pointer-events:none;}
.vt-corner{position:absolute;width:84px;height:84px;}
.vt-corner-tl{top:5px;left:5px;}
.vt-corner-tr{top:5px;right:5px;transform:scaleX(-1);}
.vt-corner-bl{bottom:5px;left:5px;transform:scaleY(-1);}
.vt-corner-br{bottom:5px;right:5px;transform:scale(-1,-1);}
.vt-center{text-align:center;position:relative;z-index:1;}
.vt-logo{display:block;margin:0 auto 8px;width:188px;max-width:62%;height:auto;filter:drop-shadow(0 10px 26px rgba(0,0,0,.5));}
.vt-kicker{font-family:'Cinzel',serif;color:var(--teal);font-size:12px;letter-spacing:5px;font-weight:600;text-transform:uppercase;}
.vt-divider{display:flex;align-items:center;justify-content:center;gap:14px;margin:18px auto;max-width:300px;}
.vt-divider i{height:1px;flex:1;background:linear-gradient(90deg,transparent,var(--line));}
.vt-divider i.r{background:linear-gradient(270deg,transparent,var(--line));}
.vt-diamond{width:7px;height:7px;transform:rotate(45deg);background:var(--gold);box-shadow:0 0 0 3px rgba(201,168,76,.10);}
.vt-headline{font-family:'Playfair Display',serif;font-weight:600;font-size:38px;line-height:1.08;margin:4px 0 12px;
  background:linear-gradient(180deg,var(--gold-lt),var(--gold) 60%,var(--gold-dk));-webkit-background-clip:text;background-clip:text;color:transparent;}
.vt-lead{color:var(--muted);font-size:15px;line-height:1.65;max-width:440px;margin:0 auto;}

.vt-qr-box{display:inline-block;padding:14px;background:#fff;border-radius:12px;box-shadow:0 14px 40px rgba(0,0,0,.45);}
.vt-qr-box img{display:block;width:172px;height:172px;}
.vt-qr-caption{font-family:'Cinzel',serif;color:var(--muted);font-size:11px;letter-spacing:2px;text-transform:uppercase;margin-top:11px;}

.vt-options{margin-top:6px;text-align:left;display:flex;flex-direction:column;gap:12px;}
.vt-option{width:100%;min-height:64px;box-sizing:border-box;text-align:left;cursor:pointer;transition:.15s;
  background:rgba(255,255,255,.03);border:1px solid var(--line);border-radius:11px;padding:16px 18px;color:var(--text);}
.vt-option:hover:not(:disabled){border-color:var(--gold);background:rgba(201,168,76,.07);transform:translateY(-1px);box-shadow:0 10px 26px rgba(0,0,0,.35);}
.vt-option:active:not(:disabled){transform:scale(.99);}
.vt-option:disabled{opacity:.55;cursor:default;}
.vt-option-name{font-family:'Cinzel',serif;font-size:16px;letter-spacing:.5px;font-weight:600;color:var(--gold-lt);}
.vt-option-project{font-family:'Playfair Display',serif;font-size:14px;color:var(--muted);margin-top:5px;line-height:1.45;}

.vt-results{margin-top:6px;text-align:left;}
.vt-result{margin-bottom:18px;}
.vt-result-head{display:flex;justify-content:space-between;align-items:baseline;gap:12px;margin-bottom:8px;}
.vt-result-name{font-family:'Cinzel',serif;font-size:14px;letter-spacing:.4px;color:var(--text);}
.vt-result-name.lead{color:var(--gold-lt);}
.vt-result-count{font-family:'Cinzel',serif;font-size:12px;letter-spacing:1px;color:var(--muted);white-space:nowrap;}
.vt-bar{height:10px;border-radius:99px;background:rgba(255,255,255,.06);overflow:hidden;}
.vt-bar-fill{height:100%;border-radius:99px;background:linear-gradient(90deg,var(--gold-dk),var(--gold) 55%,var(--gold-lt));transition:width .6s cubic-bezier(.16,1,.3,1);}
.vt-bar-fill.teal{background:linear-gradient(90deg,#1f8f88,var(--teal));}

.vt-tick{width:62px;height:62px;border-radius:50%;margin:4px auto 12px;display:flex;align-items:center;justify-content:center;
  border:2px solid var(--gold);color:var(--gold-lt);font-size:30px;background:rgba(201,168,76,.08);}
.vt-thanks{font-family:'Playfair Display',serif;font-weight:600;font-size:27px;margin:6px 0 4px;
  background:linear-gradient(180deg,var(--gold-lt),var(--gold-dk));-webkit-background-clip:text;background-clip:text;color:transparent;}
.vt-note{background:rgba(55,208,196,.07);border:1px solid rgba(55,208,196,.25);color:#9fe8e0;border-radius:10px;padding:11px 14px;font-size:13.5px;}
.vt-error{background:rgba(220,80,80,.10);border:1px solid rgba(220,80,80,.4);color:#f0b4b4;border-radius:10px;padding:11px 14px;font-size:13.5px;}
.vt-fine{text-align:center;color:var(--muted);font-size:12px;margin-top:16px;}
.vt-footer{margin-top:22px;text-align:center;font-family:'Cinzel',serif;color:var(--teal);font-size:11px;letter-spacing:2.5px;text-transform:uppercase;}
.vt-spin{width:34px;height:34px;margin:14px auto;border:2px solid rgba(201,168,76,.2);border-top-color:var(--gold);border-radius:50%;animation:vtspin .8s linear infinite;}
@keyframes vtspin{to{transform:rotate(360deg)}}
.vt-closed{width:66px;height:66px;border-radius:50%;margin:6px auto 14px;display:flex;align-items:center;justify-content:center;
  border:1px solid var(--line);background:rgba(201,168,76,.06);animation:vtpulse 2.6s ease-in-out infinite;}
@keyframes vtpulse{0%,100%{opacity:.55;transform:scale(1)}50%{opacity:1;transform:scale(1.04)}}

@media(max-width:480px){.vt-frame{padding:46px 22px 30px}.vt-headline{font-size:31px}.vt-qr-box img{width:150px;height:150px}}
`;

const Defs = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
    <defs>
      <linearGradient id="vtGold" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#e7ca72" /><stop offset=".55" stopColor="#c9a84c" /><stop offset="1" stopColor="#8f6f2c" />
      </linearGradient>
      <linearGradient id="vtTeal" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#5fe6da" /><stop offset="1" stopColor="#2bb8ad" />
      </linearGradient>
    </defs>
  </svg>
);

const Corner = ({ pos }) => (
  <svg className={'vt-corner vt-corner-' + pos} width="84" height="84" viewBox="0 0 120 120" aria-hidden="true">
    <g fill="none" stroke="url(#vtGold)" strokeWidth="1.5" strokeLinecap="round">
      <path d="M18 60 L18 18 L60 18" />
      <path d="M26 52 L26 26 L52 26" />
      <path d="M26 26 C 44 28, 52 36, 52 52" />
      <path d="M18 18 C 32 10, 46 10, 58 14" />
      <path d="M18 18 C 10 32, 10 46, 14 58" />
      <path d="M52 52 C 60 44, 66 42, 76 42" />
      <path d="M52 52 C 44 60, 42 66, 42 76" />
    </g>
    <circle cx="52" cy="52" r="2.4" fill="url(#vtGold)" />
    <circle cx="76" cy="42" r="1.7" fill="url(#vtTeal)" />
    <circle cx="42" cy="76" r="1.7" fill="url(#vtTeal)" />
  </svg>
);

const Divider = () => (
  <div className="vt-divider"><i /><span className="vt-diamond" /><i className="r" /></div>
);

export default function VotePage() {
  const [poll, setPoll] = useState(null);
  const [status, setStatus] = useState('loading');
  const [voted, setVoted] = useState(false);
  const [casting, setCasting] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState('');
  const [qr, setQr] = useState('');
  const timerRef = useRef(null);

  useEffect(() => {
    QRCode.toDataURL('https://futurumawards.com/vote', {
      width: 340, margin: 1, errorCorrectionLevel: 'H',
      color: { dark: '#071327', light: '#ffffff' },
    }).then(setQr).catch(() => {});
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/api/public/poll');
        if (res.status === 404) { setStatus('none'); return; }
        if (!res.ok) throw new Error();
        const data = await res.json();
        setPoll(data);
        if (data.has_voted) setVoted(true);
        setStatus('ready');
      } catch {
        setError('Unable to load voting. Please refresh the page.');
        setStatus('error');
      }
    })();
  }, []);

  const fetchResults = useCallback(async () => {
    if (!poll?.id) return;
    try {
      const res = await fetch(`/api/public/poll/${poll.id}/results`);
      if (res.ok) setResults(await res.json());
    } catch { /* silent */ }
  }, [poll?.id]);

  useEffect(() => {
    if (!voted || !poll?.id) return;
    fetchResults();
    timerRef.current = setInterval(fetchResults, 3000);
    return () => clearInterval(timerRef.current);
  }, [voted, poll?.id, fetchResults]);

  const vote = async (optionId) => {
    if (casting || voted) return;
    setCasting(true); setError('');
    try {
      const res = await fetch('/api/public/poll/vote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ poll_id: poll.id, option_id: optionId }),
      });
      if (res.status === 409) { setVoted(true); return; }
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(d.error || 'Your vote could not be recorded.');
      }
      setVoted(true);
    } catch (err) {
      setError(err.message || 'Your vote could not be recorded. Please try again.');
    } finally { setCasting(false); }
  };

  const total = results?.total_votes || 0;
  const leader = results?.options ? Math.max(...results.options.map(o => o.vote_count), 0) : 0;

  return (
    <div className="vt-wrap">
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <Defs />
      <div className="vt-frame">
        <Corner pos="tl" /><Corner pos="tr" /><Corner pos="bl" /><Corner pos="br" />
        <div className="vt-center">
          <img className="vt-logo" src="/futurum-logo.png" alt="Futurum Innovation Awards" />
          <div className="vt-kicker">Season II · Grand Finale</div>
          <Divider />

          {status === 'loading' && <div className="vt-spin" />}

          {status === 'error' && <div className="vt-error">{error}</div>}

          {status === 'none' && (
            <>
              <div className="vt-closed">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="url(#vtGold)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12l2 2 4-4" /><circle cx="12" cy="12" r="9" />
                </svg>
              </div>
              <h1 className="vt-headline">Voting Is Not Yet Open</h1>
              <p className="vt-lead">
                The audience vote will open if the judges require a tiebreaker. Please keep this page
                open — it will be ready the moment your host announces it.
              </p>
              {qr && (
                <>
                  <Divider />
                  <div className="vt-qr-box"><img src={qr} alt="Scan to vote" /></div>
                  <div className="vt-qr-caption">futurumawards.com/vote</div>
                </>
              )}
            </>
          )}

          {status === 'ready' && !voted && (
            <>
              <h1 className="vt-headline">{poll.title}</h1>
              <p className="vt-lead">
                {poll.description || 'Cast your vote below. One vote per device — please choose carefully.'}
              </p>
              <Divider />
              {error && <div className="vt-error" style={{ marginBottom: 14, textAlign: 'left' }}>{error}</div>}
              <div className="vt-options">
                {poll.options?.map(o => (
                  <button key={o.id} className="vt-option" onClick={() => vote(o.id)} disabled={casting}>
                    <div className="vt-option-name">{o.label}</div>
                    {o.description && <div className="vt-option-project">{o.description}</div>}
                  </button>
                ))}
              </div>
              {casting && <div className="vt-spin" />}
              <div className="vt-fine">One vote per device · your vote is anonymous</div>
            </>
          )}

          {status === 'ready' && voted && (
            <>
              <div className="vt-tick">✓</div>
              <div className="vt-thanks">Thank You</div>
              <p className="vt-lead" style={{ marginBottom: 6 }}>Your vote has been recorded.</p>
              <Divider />

              {results ? (
                <>
                  <div className="vt-kicker" style={{ marginBottom: 16 }}>Live Results</div>
                  <div className="vt-results">
                    {results.options?.map(o => {
                      const pct = total > 0 ? Math.round((o.vote_count / total) * 100) : 0;
                      const isLead = o.vote_count > 0 && o.vote_count === leader;
                      return (
                        <div className="vt-result" key={o.id}>
                          <div className="vt-result-head">
                            <span className={'vt-result-name' + (isLead ? ' lead' : '')}>{o.label}</span>
                            <span className="vt-result-count">{o.vote_count} · {pct}%</span>
                          </div>
                          <div className="vt-bar">
                            <div className={'vt-bar-fill' + (isLead ? '' : ' teal')}
                              style={{ width: `${pct}%`, minWidth: o.vote_count > 0 ? 8 : 0 }} />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="vt-fine">
                    {total} vote{total !== 1 ? 's' : ''} cast · updating live
                  </div>
                </>
              ) : <div className="vt-spin" />}
            </>
          )}

          <div className="vt-footer">Futurum Innovation Awards</div>
        </div>
      </div>
    </div>
  );
}
